import { connect } from 'react-redux'
import NominativeWithDateForm from './NominativeWithDateForm.jsx'
import { getCollaborativeIndexationCreationFields } from '../../../../../../redux/collaborativeIndexations/selectors'

const mapStateToProps = (state) => ({
    fields: getCollaborativeIndexationCreationFields(state),
})

export const NominativeWithDateFormContainer = connect(
    mapStateToProps,
)(NominativeWithDateForm)
